import styled ,{css}from 'styled-components';
const inputLikeLabelStyles = css`
  border: none;
  outline: none;
`;
const FormWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  min-width:230px;
`;
const Label = styled.label`
  margin-bottom: 20px;
  display:flex;
  flex-direction:column;
  gap:5px;
  font-weight: bold;
`;

const Select = styled.select`
  padding: 8px;
  border: 1px solid #ccc;
  border-radius: 5px;
  margin-bottom: 20px;
  width:100%;
`;

const Button = styled.button`
  padding: 10px;
  background-color: var(--primary-color);
  color:var(--font-on-primary-color);
  border: none;
  border-radius: 5px;
  cursor: pointer;
  &:hover {
    background-color:var(--primary-hover-color);
    font-weight: 700;
  }
`;
const StyledLinkLikeButton = styled.a`
  padding: 10px;
  background-color: var(--primary-color);
  color: var(--font-on-primary-color);
  border: none;
  border-radius: 5px;
  cursor: pointer;
  text-decoration: none;
  display: inline-block;
  &:hover {
    background-color: var(--primary-hover-color);
    font-weight: 700;
  }
`;
const Input = styled.input`
  padding: 8px;
  border: 1px solid #ccc;
  border-radius: 5px;
  font-size: 15px;
  color:var(--font-on-background-color);
  width:100%;
  ${props => props.islabel=="true" ? inputLikeLabelStyles : ''}
`;
export {FormWrapper,Label, Select, Button, StyledLinkLikeButton, Input };